"use client";

import { Input } from "@/components/ui/input";
import { FormikProps } from "formik";
import { CSSProperties, ReactNode, useState } from "react";
import { Eye, EyeOff } from "lucide-react";

interface Props {
  className?: string;
  wrapClassName?: string;
  name?: string;
  type?: string;
  value?: string;
  messageError?: any;
  placeholder?: string;
  onChange?: (event: any) => void;
  disabled?: boolean;
  errStyle?: CSSProperties;
  errClass?: string;
  style?: CSSProperties;
  labelStyle?: CSSProperties;
  label?: string;
  labelClass?: string;
  formik?: FormikProps<any>;
  showMessageError?: boolean;
  suffix?: ReactNode;
  prefix?: ReactNode;
  layoutClass?: string;
  showRequireSign?: boolean;
}

export function InputPasswordField({
  messageError = "",
  onChange,
  className = "",
  wrapClassName = "",
  errStyle = {},
  errClass = "",
  label,
  labelStyle = {},
  labelClass = "",
  formik,
  name = "",
  showMessageError = true,
  suffix,
  prefix,
  layoutClass = "",
  showRequireSign = false,
  ...props
}: Props) {
  const [showPassword, setShowPassword] = useState(false);
  const isError = formik?.touched[name] && formik?.errors[name];
  const messageErr = formik?.errors[name] as string;

  return (
    <div className={`${layoutClass}`}>
      {label && (
        <div>
          <span
            className={`text-sm text-[#1C125F] mb-2 block ${labelClass}`}
            style={labelStyle}
          >
            {label}
          </span>
          {showRequireSign && <span className="ml-1 text-error">*</span>}
        </div>
      )}

      <div className="relative">
        {prefix && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2">
            {prefix}
          </div>
        )}

        <Input
          type={showPassword ? "text" : "password"}
          value={formik?.values?.[name]}
          className={`pr-10 ${prefix ? "pl-10" : ""} ${
            isError ? "border-red-500" : ""
          } ${className}`}
          onChange={(e) =>
            onChange ? onChange(e) : formik.setFieldValue(name, e.target.value)
          }
          disabled={props.disabled}
          placeholder={props.placeholder}
          {...props}
        />

        <button
          type="button"
          onClick={() => setShowPassword((prev) => !prev)}
          className="absolute right-3 top-1/2 -translate-y-1/2 focus:outline-none"
          tabIndex={-1}
        >
          {showPassword ? (
            <Eye className="w-5 h-5" />
          ) : (
            <EyeOff className="w-5 h-5" />
          )}
        </button>
      </div>

      {isError && showMessageError && (
        <p className={`text-sm text-red-500 mt-1 ${errClass}`} style={errStyle}>
          {messageError || messageErr}
        </p>
      )}
    </div>
  );
}
